export default __webpack_public_path__ + "assets/images/3.cad4c7.webp";